import { render, staticRenderFns } from "./HeaderNewCopy.vue?vue&type=template&id=5edfe4a5&scoped=true&"
import script from "./HeaderNewCopy.vue?vue&type=script&lang=js&"
export * from "./HeaderNewCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfe4a5",
  null
  
)

export default component.exports